export default "__VITE_ASSET__D4ERaoU2__"